/*
 * pic-nn-web-ui
 *
 * Web UI for neural network applications.
 *
 * @copyright 2020 VSTE CB <http://www.vstecb.cz/>.
 * @license See LICENSE file distributed with this source code for more information.
 */

import React from "react";
import { bem } from "../shared/BEM";

/**
 * Component props
 */
export interface IPageHeaderProps {
	icon?: string;
	title: string;
	subtitle?: string;
}

/**
 * Page header component
 *
 * @param props Component props
 */
export function PageHeader(props: IPageHeaderProps) {

	const style = bem("page", "");

	return 	<header className={style.el("header").className()}>
		<div className={style.el("header-content").className()}>
			<h2 className={style.el("header-title").className()}>
				{ props.icon ?
				<i className={`mdi mdi-${props.icon}`} />
				: null }
				<span className={style.el("header-title-container").className()}>
					<span className={style.el("header-title-text").className()}>{props.title}</span>
					{ props.subtitle ?
					<span className={style.el("header-title-subtext").className()}>{props.subtitle}</span>
					: null }
				</span>
			</h2>
		</div>
	</header>;

}
